var _Defs, _Use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, LinearGradient, Stop, Symbol as _Symbol, Path, Use } from "react-native-svg";
function SvgWind(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "wind_svg__a",
    x1: 138.48,
    y1: 5.12,
    x2: 224.17,
    y2: 153.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#bec1c6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#bec1c6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#959aa2"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "wind_svg__b",
    x1: 77.66,
    y1: 96.23,
    x2: 168.99,
    y2: 254.41,
    xlinkHref: "#wind_svg__a"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0,
    stopColor: "#bec1c6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.45,
    stopColor: "#bec1c6"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#959aa2"
  })), /*#__PURE__*/React.createElement(_Symbol, {
    id: "wind_svg__c",
    viewBox: "0 0 348 240"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M267.16 24.29A40 40 0 11296 92H12",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 24,
    stroke: "url(#wind_svg__a)"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M151.16 215.71A40 40 0 10180 148H12",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 24,
    stroke: "url(#wind_svg__b)"
  })))), _Use || (_Use = /*#__PURE__*/React.createElement(Use, {
    width: 348,
    height: 240,
    transform: "translate(82 136)",
    xlinkHref: "#wind_svg__c"
  })));
}
export default SvgWind;